import React, { useContext, useEffect, useState } from "react";
import * as XLSX from 'xlsx';
import "./addAttendance.css";
import CloseIcon from "../../../images/CloseIcon.svg";
import AuthContext from "../../context/auth-context";
import { Fetchdata } from "../../hooks/getData";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
import UpperbarContext from "../../context/upperbar-context";
import Calendar from "@sbmdkl/nepali-datepicker-reactjs";
import "@sbmdkl/nepali-datepicker-reactjs/dist/index.css";
import NepaliDate  from 'nepali-date-converter';

// Nepali to English digit conversion function
const nepaliToEnglishDigits = (text) => {
  if (!text) return text;
  
  const digitMap = {
    '०': '0', '१': '1', '२': '2', '३': '3', '४': '4',
    '५': '5', '६': '6', '७': '7', '८': '8', '९': '9'
  };
  
  return text.split('').map(char => digitMap[char] || char).join('');
};

export default function BulkkAttendance({ setAtPopup, atPopup }) {
  const { mainBg, mode, sidePanelBg, appURL } = useContext(UpperbarContext);
  const { User } = useContext(AuthContext);

  const [file, setFile] = useState(null);
  const [fileError, setFileError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [dateFormat, setDateFormat] = useState('E');
  const [excelFormat, setExcelFormat] = useState('format1');
  const [isDownloading, setIsDownloading] = useState(false);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [fromDateNp, setFromDateNp] = useState('');
  const [toDateNp, setToDateNp] = useState('');

  useEffect(() => {
    if (atPopup) {
      $(".addAttPopBg").fadeIn(500);
      $(".addAttPop").slideDown(500);
      
      // Initialize dates with default values
      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);
      
      setFromDate(today.toISOString().split('T')[0]);
      setToDate(tomorrow.toISOString().split('T')[0]);
      
      // Initialize Nepali dates and convert to English digits
      const todayNepali = new NepaliDate().format('YYYY-MM-DD');
      const tomorrowNepali = new NepaliDate();
      tomorrowNepali.setDate(tomorrowNepali.getDate() + 1);
      
      // Convert to English digits
      setToDateNp(nepaliToEnglishDigits(tomorrowNepali.format('YYYY-MM-DD')));
      setFromDateNp(nepaliToEnglishDigits(todayNepali));
    }
  }, [atPopup]);

  const closePopUp = () => {
    setAtPopup(false);
    $(".addAttPopBg").fadeOut(500);
    $(".addAttPop").slideUp(500);
    setFile(null);
    setFileError('');
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;
    
    const validTypes = [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'text/csv'
    ];
    
    if (!validTypes.includes(selectedFile.type)) {
      setFileError('Please select a valid Excel file (.xlsx, .xls, .csv)');
      return;
    }

    setFile(selectedFile);
    setFileError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    if (!file) {
      setFileError('Please select a file first');
      setIsSubmitting(false);
      return;
    }

    try {
      const data = await readExcelFile(file);
      console.log("Sending data to server:", data);

      const response = await Fetchdata({
        FetchURL: `${appURL}api/admin/create-attendance-bulk`,
        Type: "POST",
        Values: data,
        ComID: "ES45",
        AuthCode: User.AuthCode,
        UserID: User.UserID,
        AttenPlace: "O",
        AttenVia: "W",
        FiscalID: User.FiscalID || "1",
        BrachID: User.BranchID || "1",
        DFlag: dateFormat,
        Remarks: null,
        Flag: "i"
      });

      if (response.StatusCode === 200) {
        toast.success("Bulk attendance uploaded successfully");
        closePopUp();
      } else {
        throw new Error(response.message || 'Upload failed');
      }
    } catch (error) {
      toast.error(error.message || 'Error uploading attendance');
      console.error('Upload error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const readExcelFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const firstSheet = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheet];
          const rawData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
          const formattedData = [];

          if (excelFormat === 'format1') {
            const headers = rawData[0] || [];
            const dateIndex = headers.indexOf("date");
            const useridIndex = headers.indexOf("userid");
            const checkinIndex = headers.indexOf("checkin");
            const checkoutIndex = headers.indexOf("checkout");
            const attendateIndex = headers.indexOf("attendate");
            
            for (let i = 1; i < rawData.length; i++) {
              const row = rawData[i];
              if (!row || row.length < 5) continue;
              
              const date = row[dateIndex];
              const StaffID = row[useridIndex];
              const checkin = row[checkinIndex];
              const checkout = row[checkoutIndex];
              const attendate = row[attendateIndex];
              
              if (StaffID && checkin && checkout) {
                formattedData.push({
                  StaffID: String(StaffID),
                  Date: date ? formatExcelDate(date) : '',
                  CheckIn: formatTime(checkin),
                  CheckOut: formatTime(checkout),
                  AttenDate: attendate ? formatExcelDate(attendate) : formatExcelDate(date)
                });
              }
            }
          } else {
            const dates = [];
            if (rawData.length > 0) {
              for (let j = 2; j < rawData[0].length; j += 2) {
                if (rawData[0][j]) {
                  dates.push({
                    colIndex: j,
                    date: formatExcelDate(rawData[0][j])
                  });
                }
              }
            }

            for (let i = 2; i < rawData.length; i++) {
              const row = rawData[i];
              const StaffID = row[0];
              
              for (const dateInfo of dates) {
                const j = dateInfo.colIndex;
                const checkin = row[j];
                const checkout = row[j + 1];
                
                if (StaffID && dateInfo.date && checkin && checkout) {
                  formattedData.push({
                    StaffID: String(StaffID),
                    AttenDate: dateInfo.date,
                    CheckIn: formatTime(checkin),
                    CheckOut: formatTime(checkout),
                  });
                }
              }
            }
          }

          if (formattedData.length === 0) {
            throw new Error('No valid attendance records found in the Excel file');
          }
          
          resolve(formattedData);
        } catch (error) {
          reject(error);
        }
      };

      reader.onerror = (error) => reject(error);
      reader.readAsArrayBuffer(file);
    });
  };

  const formatExcelDate = (excelDate) => {
    if (typeof excelDate === 'number') {
      const date = new Date(Math.round((excelDate - 25569) * 86400 * 1000));
      return date.toISOString().split('T')[0];
    }
    
    if (typeof excelDate === 'string') {
      // Convert Nepali digits to English before processing
      const convertedDate = nepaliToEnglishDigits(excelDate);
      const datePart = convertedDate.split(' ')[0];
      
      if (datePart.match(/^\d{4}-\d{2}-\d{2}$/)) {
        return datePart;
      }
      if (datePart.match(/^\d{1,2}\/\d{1,2}\/\d{4}$/)) {
        const [month, day, year] = datePart.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      }
    }
    
    return excelDate;
  };

  const formatTime = (time) => {
    if (typeof time === 'number') {
      const totalMilliseconds = time * 24 * 60 * 60 * 1000;
      const date = new Date(totalMilliseconds);
      const hours = date.getUTCHours().toString().padStart(2, '0');
      const minutes = date.getUTCMinutes().toString().padStart(2, '0');
      const seconds = date.getUTCSeconds().toString().padStart(2, '0');
      return `${hours}:${minutes}:${seconds}`;
    }
    
    if (typeof time === 'string') {
      let cleanTime = time.trim().toUpperCase();
      
      if (cleanTime.includes('AM') || cleanTime.includes('PM')) {
        const [timePart, period] = cleanTime.split(' ');
        const [hours, minutes, seconds] = timePart.split(':').map(Number);
        
        let militaryHours = hours;
        if (period === 'PM' && hours < 12) militaryHours = hours + 12;
        if (period === 'AM' && hours === 12) militaryHours = 0;
        
        return [
          militaryHours.toString().padStart(2, '0'),
          (minutes || 0).toString().padStart(2, '0'),
          (seconds || 0).toString().padStart(2, '0')
        ].join(':');
      }
      
      if (cleanTime.match(/^\d{1,2}:\d{2}$/)) {
        return `${cleanTime}:00`;
      }
      
      if (cleanTime.match(/^\d{1,2}:\d{2}:\d{2}$/)) {
        const [hours, minutes, seconds] = cleanTime.split(':');
        return [
          hours.padStart(2, '0'),
          minutes.padStart(2, '0'),
          seconds.padStart(2, '0')
        ].join(':');
      }
    }
    
    return String(time);
  };

  const downloadSampleFormat = async () => {
    setIsDownloading(true);
    
    try {
      // Use appropriate dates based on selected format
      const fromDateToUse = dateFormat === 'E' ? fromDate : fromDateNp;
      const toDateToUse = dateFormat === 'E' ? toDate : toDateNp;
      
      if (!fromDateToUse || !toDateToUse) {
        throw new Error('Please select both From Date and To Date');
      }
      
      const response = await Fetchdata({
        FetchURL: `${appURL}api/admin/create-attendance-bulk`,
        Type: "POST",
        Values: null,
        ComID: "ES45",
        AuthCode: User.AuthCode,
        UserID: User.UserID,
        FromDate: fromDateToUse,
        ToDate: toDateToUse,
        DFlag: dateFormat,
        Flag: "SD"
      });

      if (response.Values && response.Values.length > 0) {
        let dataToExport;
        let filename;
        
        if (excelFormat === 'format1') {
          dataToExport = response.Values.map(item => ({
            date: item.date,
            userid: item.userid,
            fullname: item.fullname,
            checkin: item.checkin,
            checkout: item.checkout,
            attendate: item.attendate
          }));
          filename = "Attendance_Sample_Format1.xlsx";
        } else {
          // Generate dates between fromDate and toDate
          const dateArray = [];
          
          if (dateFormat === 'E') {
            // English date range
            const start = new Date(fromDateToUse);
            const end = new Date(toDateToUse);
            let current = new Date(start);
            
            while (current <= end) {
              dateArray.push(current.toISOString().split('T')[0]);
              current.setDate(current.getDate() + 1);
            }
          } else {
            // Nepali date range
            let current = new NepaliDate(fromDateToUse);
            const end = new NepaliDate(toDateToUse);
            
            while (current <= end) {
              // Convert to English digits
              dateArray.push(nepaliToEnglishDigits(current.format('YYYY-MM-DD')));
              current = current.add(1, 'days');
            }
          }
          
          dataToExport = [
            ["userid", "fullname", ...dateArray.flatMap(date => [date, ""])],
            ["", "", ...dateArray.flatMap(() => ["checkin", "checkout"])],
            ...response.Values.slice(0, 3).map(item => [
              item.userid,
              item.fullname,
              ...dateArray.flatMap(() => ["09:00:00", "17:00:00"])
            ])
          ];
          filename = "Attendance_Sample_Format2.xlsx";
        }

        let ws;
        if (excelFormat === 'format1') {
          ws = XLSX.utils.json_to_sheet(dataToExport);
        } else {
          ws = XLSX.utils.aoa_to_sheet(dataToExport);
        }
        
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Attendance");
        XLSX.writeFile(wb, filename);
        toast.success("Sample downloaded successfully");
      } else {
        throw new Error('No sample data found');
      }
    } catch (error) {
      toast.error(error.message || 'Error downloading sample');
      console.error('Download error:', error);
    } finally {
      setIsDownloading(false);
    }
  };

  const handleNepaliDateChange = (setter) => (date) => {
    // Convert Nepali digits to English before saving
    setter(nepaliToEnglishDigits(date.bsDate));
  };

  return (
    <>
      <ToastContainer />
      <style>
        {`
          .nepali-date-picker .calendar-header .np-calendar-header-text,
          .nepali-date-picker .calendar-body .np-calendar-cell,
          .nepali-date-picker .calendar-body .np-calendar-week-cell {
            font-family: Arial, sans-serif !important;
          }
          
          .nepali-date-picker .calendar-body .np-calendar-cell:before {
            content: attr(data-english-digit);
            display: block;
          }
          
          .nepali-date-picker .calendar-body .np-calendar-cell span {
            display: none;
          }
        `}
      </style>
      <div className="container newpopup-bg addAttPopBg">
        <div className="newpopup addAttPop " style={mainBg}>
          <div className="newpopup-head ps-0 pe-0" style={sidePanelBg}>
            <div className="popUpTitle">
              {mode === "en" ? "Bulk Attendance" : "उपस्थिति थप्नुहोस्"}
            </div>
            <div className="popUpClose">
              <img
                className="popUpCloseIcon"
                src={CloseIcon}
                alt="CloseIcon"
                onClick={closePopUp}
              />
            </div>
          </div>
          <div
            className="newpopup-body ps-3 pe-3 "
            style={{ maxHeight: "60vh", overflowY: "auto" }}
          >
            <div className="form-padding">
              {/* Row 1: Date Format */}
              <div className="row text-start mb-3 mt-3">
                <div className="col-md-12">
                  <div className="form-label" style={{ fontSize: "12px", textAlign: "left" }}>
                    {mode === "en" ? "Date Format" : "मिति ढाँचा"}
                  </div>
                  <select 
                    className="form-select form-select-sm"
                    value={dateFormat}
                    onChange={(e) => setDateFormat(e.target.value)}
                    disabled={isSubmitting || isDownloading}
                  >
                    <option value="E">{mode === "en" ? "English Date" : "अंग्रेजी मिति"}</option>
                    <option value="D">{mode === "en" ? "Nepali Date" : "नेपाली मिति"}</option>
                  </select>
                </div>
              </div>
              
              {/* Row 2: From Date and To Date */}
              <div className="row text-start mt-3 mb-3">
                <div className="col-md-6">
                  <div className="form-label" style={{ fontSize: "12px", textAlign: "left" }}>
                    {mode === "en" ? "From Date" : "सुरु मिति"}
                  </div>
                  
                  {dateFormat === 'E' ? (
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      disabled={isDownloading}
                    />
                  ) : (
                    <div className="english-digit-calendar">
                      <Calendar
                        className="form-control form-control-sm"
                        value={fromDateNp}
                        onChange={handleNepaliDateChange(setFromDateNp)}
                       dateFormat="YYYY/MM/DD"
                       language="en"
                        readOnly={isDownloading}
                      />
                    </div>
                  )}
                </div>
                <div className="col-md-6">
                  <div className="form-label" style={{ fontSize: "12px", textAlign: "left" }}>
                    {mode === "en" ? "To Date" : "अन्तिम मिति"}
                  </div>
                  
                  {dateFormat === 'E' ? (
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      disabled={isDownloading}
                    />
                  ) : (
                    <div className="english-digit-calendar">
                      <Calendar
                        className="form-control form-control-sm"
                        value={toDateNp}
                        onChange={handleNepaliDateChange(setToDateNp)}
                         dateFormat="YYYY/MM/DD"
                       language="en"
                        readOnly={isDownloading}
                      />
                    </div>
                  )}
                </div>
              </div>
              
              {/* Row 3: Excel Format Selection */}
              <div className="row text-start">
                <div className="col-md-8">
                  <div className="form-label" style={{ fontSize: "12px", textAlign: "left" }}>
                    {mode === "en" ? "Excel Format" : "एक्सेल ढाँचा"}
                  </div>
                  <select 
                    className="form-select form-select-sm"
                    value={excelFormat}
                    onChange={(e) => setExcelFormat(e.target.value)}
                    disabled={isSubmitting || isDownloading}
                  >
                    <option value="format1">Format 1 (Simple)</option>
                    <option value="format2">Format 2 (Date Columns)</option>
                  </select>
                </div>
             
                <div className="col-md-4 mt-4">
                  <button
                    className="btn btn-sm w-100"
                    style={{ 
                      background: "var(--button-color)", 
                      color: "white",
                      opacity: isDownloading ? 0.5 : 1
                    }}
                    onClick={downloadSampleFormat}
                    disabled={isDownloading}
                  >
                    {isDownloading 
                      ? (mode === "en" ? "Downloading..." : "डाउनलोड हुँदैछ...") 
                      : (mode === "en" ? "Download Format" : "नमूना ढाँचा डाउनलोड गर्नुहोस्")
                    }
                  </button>
                </div>
              </div>
              
              {/* Row 5: Upload Section */}
              <div className="row text-start ">
                <div className="form-group">
                  <div className="form-label" style={{ fontSize: "12px", textAlign: "left" }}>
                    {mode === "en" ? "Upload Excel File" : "एक्सेल फाइल अपलोड गर्नुहोस्"}
                  </div>

                  <input
                    type="file"
                    accept=".xlsx, .xls, .csv"
                    onChange={handleFileChange}
                    className="form-control"
                    disabled={isSubmitting}
                  />
                  
                  {fileError && (
                    <div className="text-danger small mt-1">{fileError}</div>
                  )}
                  
                  <div className="mt-2 small text-muted">
                    {excelFormat === 'format1' 
                      ? (mode === "en" 
                          ? "File must contain columns: date, userid, fullname, checkin, checkout, attendate" 
                          : "फाइलमा यी स्तम्भहरू हुनुपर्छ: date, userid, fullname, checkin, checkout, attendate")
                      : (mode === "en" 
                          ? "File must have: 1st row = dates, 2nd row = checkin/checkout labels, 3rd+ rows = staff data" 
                          : "फाइलमा: पहिलो पंक्ति = मितिहरू, दोस्रो पंक्ति = चेकइन/चेकआउट लेबल, तेस्रो+ पंक्ति = कर्मचारी डाटा")
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="new-footer">
            <div className="row mt-1 mb-1">
              <div>
                <button
                  type="button"
                  className={`btn btn-sm me-2 ${isSubmitting ? 'disabled' : ''}`}
                  style={{ 
                    background: "var(--button-color)", 
                    color: "white",
                    opacity: isSubmitting ? 0.5 : 1
                  }}
                  onClick={handleSubmit}
                  disabled={isSubmitting}
                >
                  {isSubmitting 
                    ? (mode === "en" ? "Uploading..." : "अपलोड गर्दै...") 
                    : (mode === "en" ? "Upload Data" : "बुझाउनुहोस्")
                  }
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-danger me-3"
                  style={{ color: "white" }}
                  onClick={closePopUp}
                  disabled={isSubmitting}
                >
                  {mode === "en" ? "Cancel" : "बन्द गर्नुहोस्"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}